{
  "$id": "compliance-pack",
  "type": "object",
  "additionalProperties": false,
  "required": ["kind", "name", "framework", "disclaimer", "mappings"],
  "properties": {
    "kind": { "const": "compliance-pack" },
    "name": { "type": "string", "pattern": "^[a-z0-9]+(?:-[a-z0-9]+)*$" },
    "description": { "type": "string", "minLength": 1 },
    "maintainer": { "type": "string", "minLength": 1 },
    "framework": {
      "type": "object",
      "additionalProperties": false,
      "required": ["id", "title"],
      "properties": {
        "id": { "type": "string", "pattern": "^[a-z0-9]+(?:-[a-z0-9]+)*$" },
        "title": { "type": "string", "minLength": 1 },
        "authority_url": { "type": "string", "minLength": 1 },
        "version": { "type": "string", "minLength": 1 }
      }
    },
    "disclaimer": { "type": "string", "minLength": 1 },
    "mappings": {
      "type": "array",
      "minItems": 1,
      "items": { "$ref": "#/$defs/mapping" }
    }
  },
  "$defs": {
    "mapping": {
      "type": "object",
      "additionalProperties": false,
      "required": ["clause", "satisfied_by", "evidence_strength"],
      "properties": {
        "clause": {
          "type": "object",
          "additionalProperties": false,
          "required": ["id", "title"],
          "properties": {
            "id": { "type": "string", "minLength": 1 },
            "title": { "type": "string", "minLength": 1 },
            "url": { "type": "string", "minLength": 1 }
          }
        },
        "satisfied_by": {
          "type": "array",
          "minItems": 1,
          "items": { "$ref": "#/$defs/signal" }
        },
        "evidence_strength": {
          "type": "string",
          "enum": ["partial", "substantial"]
        },
        "reviewed_by": { "type": "string", "minLength": 1 }
      }
    },
    "signal": {
      "type": "object",
      "additionalProperties": false,
      "required": ["type", "ref", "relation"],
      "properties": {
        "type": { "type": "string", "enum": ["gate", "obligation_category"] },
        "ref": { "type": "string", "minLength": 1 },
        "relation": {
          "type": "string",
          "enum": [
            "equivalent-to",
            "equal-to",
            "subset-of",
            "superset-of",
            "intersects-with",
            "no-relationship"
          ]
        }
      }
    }
  }
}
